import { DynamicPropertyToGroupDtoToEntity } from "src/app/features/DynamicPropertyGroup/services/mappers/DynamicPropertyToGroupDtoToEntity";
import type { DynamicPropertyToGroupDto } from "src/app/features/DynamicPropertyGroup/types/DynamicPropertyToGroupDto";
import type { DynamicPropertyToGroupEntity } from "src/app/features/DynamicPropertyGroup/types/DynamicPropertyToGroupEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const DynamicPropertyToGroupTableDtoMapper = (
    input: Readonly<ResourcePageDto<DynamicPropertyToGroupDto>>,
): ResourcePageEntity<DynamicPropertyToGroupEntity> => {
    return {
        list: input.list ? input.list.map(DynamicPropertyToGroupDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
